<!--
* 作用于哪些页面
* 面包屑/
  breadcrumbName为一个对象
  secondName: '二级名称',
  secondPath: '二级路径',
  threeName: '三级名称'
* @authors zzt
* @date 2019-01-28
* @version 1.0
-->
<template>
  <div class="breadcrumb-box">
    <div>
      <!-- <el-breadcrumb separator="/"> -->
      <el-breadcrumb :separator="breadcrumbName.icon?breadcrumbName.icon:'/'">
        <el-breadcrumb-item class="titleShow">
          <img
            src="@/assets/redesignImg/address.png"
            alt=""
          ></el-breadcrumb-item>
        <!-- <el-breadcrumb-item
          class="titleShow"
          v-if="breadcrumbName.title"
        >{{breadcrumbName.title}}</el-breadcrumb-item> -->
        <el-breadcrumb-item
          v-if="breadcrumbName.fristName"
          :to="{ path: breadcrumbName.fristPath}"
        >{{breadcrumbName.fristName}}</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="breadcrumbName.secondName"
          :to="{ path: breadcrumbName.secondPath }"
        >{{breadcrumbName.secondName}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumbName.threeName">{{breadcrumbName.threeName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbName: {
      type: Object,
      required: true
    }
  },
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  created () {},
  mounted () {}
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@media screen and (min-width: 1218px) {
  .breadcrumb-box {
    width: 1200px;
    margin: 0 auto;
    // background: url('../../assets/public/location.png') no-repeat left center;
    > div {
      margin: 10px 0 10px 5px;
    }
  }
}
@media screen and (max-width: 1217px) {
  .breadcrumb-box {
    width: 90%;
    // background: url('../../assets/public/location.png') no-repeat 20px 22px;
    > div {
      margin: 10px 0 10px 40px;
    }
  }
}

@media screen and (max-width: 992px) {
  .breadcrumb-box {
    width: 890px;
    > div {
      margin: 10px 0 10px 40px;
    }
  }
}
/* 面包屑 */
.breadcrumb-box {
  overflow: hidden;
}
</style>
<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.is-link {
  &:hover {
    color: $default !important;
  }
}
.titleShow {
  img {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .el-breadcrumb__separator {
    display: none;
  }
}
</style>
